import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichTextEditor.css';

const loadedFonts = new Set();

const FONTS = [
    { label: 'Sans Serif', value: 'sans-serif' },
    { label: 'Serif', value: 'serif' },
    { label: 'Monospace', value: 'monospace' },
    { label: 'Arial', value: 'arial' },
    { label: 'Times New Roman', value: 'times-new-roman' },
    { label: 'Roboto', value: 'roboto' },
    { label:'Satoshi', value:'satoshi' },
    { label:'ComicNeue', value:'comicneue' },
    { label:'BebasNeue', value:'bebasneue' },
    { label:'ComicRelief', value:'comicrelief' },
    { label:'Lora', value:'lora' },
    { label:'Montserrat', value:'montserrat' },
    { label:'Oswald', value:'oswald' },
    { label:'Pacifico', value:'pacifico' },
    { label:'PlayfairDisplay', value:'playfairdisplay' },
  ];
  
  const FONT_FILES = {

    "satoshi": {
      family: "Satoshi",
      url: "/fonts/static/Satoshi-Regular.ttf"
    },
    "comicneue": {
      family: "ComicNeue",
      url: "/fonts/static/ComicNeue-Regular.ttf"
    },
    "bebasneue": {
      family: "BebasNeue",
      url: "/fonts/static/BebasNeue-Regular.ttf"
    },
    "comicrelief": {
      family: "ComicRelief",
      url: "/fonts/static/ComicRelief-Regular.ttf"
    },    
    "lora": {
      family: "Lora",
      url: "/fonts/static/Lora-Regular.ttf"
    },    
    "montserrat": {
      family: "Montserrat",
      url: "/fonts/static/Montserrat-Regular.ttf"
    },
    "oswald": {
      family: "Oswald",
      url: "/fonts/static/Oswald-Regular.ttf"
    },
    "pacifico": {
      family: "Pacifico",
      url: "/fonts/static/Pacifico-Regular.ttf"
    },
    "playfairdisplay": {
      family: "PlayfairDisplay",
      url: "/fonts/static/PlayfairDisplay-Regular.ttf"
    }
  };

// Register the font format with whitelist
const Font = ReactQuill.Quill.import('formats/font');
Font.whitelist = FONTS.map(f => f.value);
ReactQuill.Quill.register(Font, true);


// Extend size whitelist
// Register size with specific px values instead of symbolic names
const SizeStyle = ReactQuill.Quill.import('attributors/style/size');
SizeStyle.whitelist = ['10px', '12px', '14px', '16px', '18px', '24px', '32px', '40px', '48px','56px','64px'];
ReactQuill.Quill.register(SizeStyle, true);

// const Size = ReactQuill.Quill.import('attributors/style/size');
// Size.whitelist = ['small', 'normal', 'large', 'huge'];
// ReactQuill.Quill.register(Size, true);

const RichTextEditor = ({ value = '', onHtmlChange, rect }) => {
  const [editorValue, setEditorValue] = useState(value);
  const quillRef = useRef();


  useEffect(() => {
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      const tooltip = quill.theme.tooltip;
  
      let adjusting = false;
  
      const adjustTooltip = () => {
        if (adjusting) return;
  
        if (tooltip.root.classList.contains('ql-hidden')) {
          return;
        }
  
        setTimeout(() => {
          if (adjusting) return;
  
          const tooltipRect = tooltip.root.getBoundingClientRect();
          const editorRect = quill.root.getBoundingClientRect();
  
          let left = parseInt(tooltip.root.style.left || "0", 10);
          let top = parseInt(tooltip.root.style.top || "0", 10);
  
          let changed = false;
  
          if (tooltipRect.left < editorRect.left) {
            left += editorRect.left - tooltipRect.left + 10;
            changed = true;
          }
  
          if (tooltipRect.right > editorRect.right) {
            left -= tooltipRect.right - editorRect.right + 10;
            changed = true;
          }
  
          if (tooltipRect.bottom > editorRect.bottom) {
            top -= tooltipRect.bottom - editorRect.bottom + 10;
            changed = true;
          }
  
          if (tooltipRect.top < editorRect.top) {
            top += editorRect.top - tooltipRect.top + 10;
            changed = true;
          }
  
          if (changed) {
            adjusting = true;
  
            tooltip.root.style.left = `${left}px`;
            tooltip.root.style.top = `${top}px`;
  
            // allow future tooltip movements
            setTimeout(() => {
              adjusting = false;
            }, 50);
          }
  
        }, 10);
      };
  
      const observer = new MutationObserver(adjustTooltip);
  
      observer.observe(tooltip.root, {
        attributes: true,
        attributeFilter: ['class']
      });
  
      return () => {
        observer.disconnect();
      };
    }
  }, []);


  useEffect(() => {

    if (!quillRef.current) return;
  
    const quill = quillRef.current.getEditor();
          
    Object.keys(FONT_FILES).forEach(font => {
        loadFont(font);
    });
    
    
    quill.on("selection-change", () => {
  
      const range = quill.getSelection();
  
      if (!range) return;
  
  
      const format = quill.getFormat(range);
  
      if (format.font) {
        loadFont(format.font);
      }  
    }); 
    
    setEditorValue(value);
    
      
  }, []);

/*
  useEffect(() => {
    rect.richText = value;
    if (!quillRef.current) return;
  
    const editor = quillRef.current.getEditor();
  
    if (editor.root.innerHTML !== value) {
  
      loadFontsFromHTML(value);
  
      // wait one tick for @font-face injection
      setTimeout(() => {
        editor.clipboard.dangerouslyPasteHTML(value);
        setEditorValue(value);
      }, 0);
    }
  
  }, [value]);
  */

  
  useEffect(() => {
    // setEditorValue(value);
    // rect.richText = value;
    // Apply font-family and font-size from HTML if present
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      // const formattedHTML = value.replace(/<span class="ql-font-comic-sans">/g, '<span style="font-family: \'Comic Sans MS\', cursive;">');
      //setEditorValue(formattedHTML);

      if(editor.root.innerHTML !== value)
      {
              // Correct the font-family for Comic Sans
        // const formattedHTML = value.replace(/<span class="ql-font-comic-sans">/g, '<span style="font-family: \'Comic Sans MS\', cursive;">');
              // Correct the font-family for Comic Sans        

        loadFontsFromHTML(value);

        editor.clipboard.dangerouslyPasteHTML(value);       
        setEditorValue(value);
      }
    }

  }, [value]);
  

  const handleChange = (content, delta, source, editor) => {
    setEditorValue(content);
    // rect.richText = editor.getHTML();
    // rect.plainText = editor.getText();

    if (onHtmlChange) {
      onHtmlChange(editor.getHTML(), editor.getText());
    }
  };


  const modules = {
    toolbar: [
      [{ font: FONTS.map(f => f.value) }],
      [{ size: SizeStyle.whitelist  }],
      ['bold', 'italic', 'underline'],
      [{ color: [] }, { background: [] }],
      ['link'],      
      ['clean'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ]  
  };
  

  const formats = [
    'list',
    'font', 'size',
    'bold', 'italic', 'underline',
    'color', 'background',
    'link'
  ];

  return (
    <div className="rich-text-editor">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={editorValue}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder="Enter rich text here..."
      />
    </div>
  );
};





function loadFont(fontName) {

  if (loadedFonts.has(fontName)) {
    return;
  }

  const font = FONT_FILES[fontName];

  if (!font) return;


  const style = document.createElement("style");

  style.innerHTML = `
    @font-face {
      font-family: "${font.family}";
      src: url("${font.url}") format("truetype");
      font-display: swap;
    }

    .ql-font-${fontName} {
      font-family: "${font.family}";
    }
  `;

  document.head.appendChild(style);

  loadedFonts.add(fontName);
}



function loadFontsFromHTML(html) {
  const div = document.createElement("div");
  div.innerHTML = html;

  const elements = div.querySelectorAll("[class]");

  elements.forEach(el => {
    el.classList.forEach(cls => {
      if (cls.startsWith("ql-font-")) {
        const fontName = cls.replace("ql-font-", "");
        loadFont(fontName);
      }
    });
  });
}

export default RichTextEditor;


